import React from 'react';
import OnBoardingRender from './OnBoardingRender';

export const OnBoarding = ():JSX.Element=>{

	return <OnBoardingRender />;
};